import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterBySupplierPayment',
    pure: false
})
export class FilterBySupplierPaymentPipe implements PipeTransform {
  transform(items: any[], searchText: string): any {
    if (!items || !searchText) {
      return items;
    }

    // Funcion para quitar acentos de una cadena
    const removeAccents = (str: string) => {
      if(!str) return '';

      const accents: { [key: string]: string } = {'á':'a','é':'e','í':'i','ó':'o','ú':'u','Á':'A','É':'E','Í':'I','Ó':'O','Ú':'U'};
      return str.replaceAll(/[áéíóúÁÉÍÓÚ]/g, (match) => accents[match] || match);
    }

    const searchTextNoAccents = searchText.toLocaleLowerCase().normalize("NFD").replaceAll(/[\u0300-\u036f]/g, "");

    return items.filter((it) => {
      return (
        removeAccents(it.taskType)?.toLowerCase().includes(searchTextNoAccents) ||
        removeAccents(it.taskDate)?.includes(searchTextNoAccents) ||
        removeAccents(it.contractorName)?.toLowerCase().includes(searchTextNoAccents) ||
        removeAccents(it.productName)?.toLowerCase().includes(searchTextNoAccents) ||
        removeAccents(it.clientCity)?.toLowerCase().includes(searchTextNoAccents) ||
        removeAccents(it.clientName)?.toLowerCase().includes(searchTextNoAccents) ||
        (typeof it.amount === 'string' ? removeAccents(it.amount).includes(searchTextNoAccents) : (it.amount && it.amount.toString().includes(searchTextNoAccents)))
      );
    });
  }
}
